import { useSearchParams, useNavigate } from 'react-router-dom';

// Import your properly named Step Components
import DoctorStep2 from './DoctorStep2'; // Now Qualification
import DoctorStep3 from './DoctorStep3'; // Now Identity
import DoctorStep4 from './DoctorStep4'; // Now Registration
import DoctorStep5 from './DoctorStep5'; // Now Establishment
import DoctorFinalStep from './DoctorFinalStep';

export default function DoctorOnboardingWrapper() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // 1. Get current step from URL (Default to 2)
  const currentStep = Number(searchParams.get('step')) || 2;

  // 2. Navigation Handler (Forward Only)
  const handleNextStep = (nextStep: number) => {
    navigate(`?step=${nextStep}`);
    window.scrollTo(0, 0); 
  };

  // 3. Final Submit Handler
  const handleFinalSuccess = () => {
    navigate('/expert/dashboard'); 
  };

  return (
    <div className="min-h-screen bg-brand-blue-900 py-12 px-4">
      <div className="max-w-4xl mx-auto space-y-6"> 
        
        {/* Progress Indicator */}
        <div className="bg-white rounded-lg shadow-xl p-6 mb-6">
          <div className="flex justify-between items-center overflow-x-auto">
            {[2, 3, 4, 5, 6].map((step) => (
              <div key={step} className="flex flex-col items-center flex-1 min-w-[80px]">
                <div
                  className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold transition-colors duration-300 ${
                    step === currentStep
                      ? 'bg-cyan-400 text-white'
                      : step < currentStep
                      ? 'bg-green-500 text-white'
                      : 'bg-gray-300 text-gray-600'
                  }`}
                >
                  {step < currentStep ? '✓' : step}
                </div>
                <p className="text-xs mt-2 text-gray-600 font-medium text-center">
                  {step === 2 && 'Qualification'}
                  {step === 3 && 'Identity'}
                  {step === 4 && 'Registration'}
                  {step === 5 && 'Clinic'}
                  {step === 6 && 'Agreement'}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Render Steps */}
        {currentStep === 2 && <DoctorStep2 onNext={() => handleNextStep(3)} />}
        {currentStep === 3 && <DoctorStep3 onNext={() => handleNextStep(4)} />}
        {currentStep === 4 && <DoctorStep4 onNext={() => handleNextStep(5)} />}
        {currentStep === 5 && <DoctorStep5 onNext={() => handleNextStep(6)} />}
        {currentStep === 6 && (
          <DoctorFinalStep 
            onSubmit={handleFinalSuccess} 
            onBack={() => {}} 
          />
        )}

      </div>
    </div>
  );
}